// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1de3dfd1","453":"21ce03cf","732":"42c987a6"}[chunkId] + ".chunk.js";
};